import { IconProps } from './types';

export const LockIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16.245 17.828'>
    <g transform='translate(-3.5 -2)'>
      <path
        // eslint-disable-next-line max-len
        d='M6.083,16.5h11.08a1.583,1.583,0,0,1,1.583,1.583v5.54a1.583,1.583,0,0,1-1.583,1.583H6.083A1.583,1.583,0,0,1,4.5,23.623v-5.54A1.583,1.583,0,0,1,6.083,16.5Z'
        transform='translate(0 -6.377)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
      <path
        d='M10.5,10.123V6.957a3.957,3.957,0,1,1,7.914,0v3.166'
        transform='translate(-2.834)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
    </g>
  </svg>
);
